import { createSlice } from "@reduxjs/toolkit";

interface ThemeState {
  mode: string;
}

const initialState: ThemeState = {
  mode: "light",
};

const ThemeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.mode = action.payload;
    },
    toggleTheme: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
  },
});

export const { setTheme, toggleTheme } = ThemeSlice.actions;
export default ThemeSlice.reducer;
